import styled from 'styled-components'

interface ElementWrapperProps {
  allowOverflow?: boolean
  useFullWidth?: boolean
}

interface ToggleButtonProps {
  autoWidth?: boolean
  disabled?: boolean
  isInput?: boolean
  loading?: boolean
}

export const ElementWrapper = styled.div<ElementWrapperProps>`
  max-width: 90%;
  overflow: ${({ allowOverflow }) => (allowOverflow ? 'visible' : 'hidden')};
  width: ${({ useFullWidth }) => (useFullWidth ? '100%' : 'auto')};
  /* Editor styles */
  .field,
  .fr-box,
  .fr-wrapper,
  .fr-toolbar {
    background: none !important;
    border: none !important;
    /* max-width: 90%; */
  }

  .fr-btn,
  .fr-svg {
    margin-top: 0 !important;
  }

  .second-toolbar {
    display: none !important;
  }

  .fr-btn-grp,
  .fr-element {
    margin: 0 !important;
    padding: 0 !important;
  }
`

export const ToggleButton = styled.div<ToggleButtonProps>`
  width: ${({ autoWidth }) => (autoWidth ? 'auto' : '75%')};
  cursor: ${props => (!props.disabled ? 'pointer' : 'initial')};

  input,
  textarea {
    background: none !important;
    color: inherit !important;
    padding: 4px !important;
    border: 0 !important;
    outline: 0 !important;
    font-family: inherit !important;
    resize: none !important;
    min-height: 0em !important;
  }

  textarea {
    width: 100%;
    line-height: 1.4;
    padding: 0;
  }

  > span {
    white-space: ${({ isInput }) => (isInput ? 'nowrap' : 'pre-wrap')};
  }

  > div {
    overflow: ${({ isInput }) => (isInput ? 'hidden' : 'visible')};
    text-overflow: ellipsis;
    white-space: pre-wrap;

    > span {
      white-space: ${({ isInput }) => (isInput ? 'nowrap' : 'pre-wrap')};
      opacity: ${props => (props.loading ? 0.5 : 1)};
    }

    p {
      max-width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
`
